import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ContactListService } from 'src/app/services/contacts/contactList/contact-list.service';
import Swal from 'sweetalert2'

declare var $: any

@Component({
  selector: 'app-events-contact-list',
  templateUrl: './events-contact-list.component.html',
  styleUrls: ['./events-contact-list.component.less']
})
export class EventsContactListComponent implements OnInit {


  SubmitLoading
  searchForm: FormGroup;
  normalEventReg: boolean = true
  appEdit: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private ContactListService: ContactListService,
    private router: ActivatedRoute
  ) {

  }

  ngOnInit() {

    this.searchForm = this.formBuilder.group({
      partnerId: [''],
      fullName: [''],
      email: [''],
      mobileNumber: [''],
    });

    this.router.params.subscribe(res => {
      if (res && res.id) {
        console.log(res)
        this.appEdit = true
        this.searchForm.patchValue({
          partnerId: res.id
        })
        this.searchUser()
      }
    })

  }


  searchUser() {
    console.log(this.searchForm.value)
    this.SubmitLoading = true
    if ((this.searchForm.value.partnerId !== '' && this.searchForm.value.partnerId !== null) || (this.searchForm.value.fullName !== '' && this.searchForm.value.fullName !== null) || (this.searchForm.value.email !== '' && this.searchForm.value.email !== null) || (this.searchForm.value.mobileNumber !== '' && this.searchForm.value.mobileNumber !== null)) {
      this.getAllContactList(this.searchForm.value)
    } else {
      this.SubmitLoading = false
      Swal.fire(
        'Search with any one key',
        'Partner Code or Full Name or Email or Mobile Number',
        'warning'
      )
    }
  }

  clearSearchForm() {
    this.searchForm.reset()
    this.allContactData = []
  }

  dqloader: boolean = false
  allContactData: any = []
  async getAllContactList(value) {
    this.dqloader = true;
    let data = {
      partner_id: value.partnerId,
      full_name: value.fullName,
      email: value.email,
      primary_mobile_no: value.mobileNumber
    }
    let response: any = await this.ContactListService.getAllContactList(data);
    console.log(response.data)
    if (response.data.length != 0) {
      this.allContactData = response.data
      this.SubmitLoading = false
      this.dqloader = false
    } else {
      this.dqloader = false
      this.SubmitLoading = false
      this.allContactData = []
    }
  }

  details: any
  viewDetails(data) {
    $("#contactDetails").modal("show");
    this.details = data
  }

  userDetails: any
  editDetails(data) {
    $("#editPartnerID").modal("show");
    this.userDetails = data
  }

  async createResponse(ele) {
    if (ele.status == 'Done') {
      this.getAllContactList({ partnerId: ele.partnerID, email: "", mobileNumber: "" })
      $("#createNewPartnerID").modal("hide");
    }
  }

  public createPartnerCodeReady: Boolean = true
  async createResponseModelReady(elm) {
    if (elm == "ready") {
      this.createPartnerCodeReady = false
    }
  }

  public showButton: Boolean = false
  async createResponseAlreadyExist(elm) {
    if (elm.key == "email") {
      this.getAllContactList({ partnerId: "", email: elm.value, mobileNumber: "" })
      $("#createNewPartnerID").modal("hide");

      this.showButton = true
    } else {
      this.getAllContactList({ partnerId: "", email: "", mobileNumber: elm.value })
      $("#createNewPartnerID").modal("hide");
      this.showButton = true
    }
  }

  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      if (event.keyCode != 13) {
        event.preventDefault();
      }
    }
  }

}
